import { Action, createAction, createReducer, on, props } from '@ngrx/store';
import merge from 'lodash/merge';

export interface User {
  bindphone: string;
  isLdapUser: boolean;
  mobilephone: number;
  nickname: string;
  orgSSOID: string;
  title: string;
  unreadMessages: number;
  useSSO: boolean;
  userLogin: string;
  userStatus: number;
  email: string;
  roles?: string[];
  permissions?: string[];
  loginMethod?: string;
  needResetPwd?: boolean;
  userId?: number;
  currentUserId?: number;
  mobileVerificationCode?: boolean;
  userRoles?: { enterpriseId: number; roleId: number; roleName: string; userId: number; userRoleId: number }[];
}

export const setUser = createAction('[User] Set User Info', props<Partial<User>>());
export const mergeUser = createAction('[User] Merge User Info', props<Partial<User>>());
export const resetUser = createAction('[User] Reset Empty User');

export function userReducer(pState: User | undefined, action: Action) {
  return createReducer(
    {},
    on(setUser, (state, user) => user),
    on(mergeUser, (state, user) => merge({}, state, user)),
    on(resetUser, state => null)
  )(pState, action);
}
